import { ReactNode } from "react";

import Button from "./Button";
import Modal from "./Modal";

interface ConfirmModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  icon?: ReactNode;
  confirmText?: string;
  cancelText?: string;
  children?: ReactNode;
}

const ConfirmModal = ({
  show,
  onClose,
  onConfirm,
  title,
  icon,
  confirmText = "OK",
  cancelText = "キャンセル",
  children
}: ConfirmModalProps) => {
  const actions = (
    <>
      <Button onClick={onConfirm} variant="primary">
        {confirmText}
      </Button>
      <Button onClick={onClose} variant="secondary">
        {cancelText}
      </Button>
    </>
  );

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={title}
      icon={icon}
      actions={actions}
    >
      {children}
    </Modal>
  );
};

export default ConfirmModal;